'use strict';

const PREFIX = 'MULLIGAN_CLIENT_TRACE';

/**
 * @param {string} event
 * @param {object} fields
 */
export function traceMulliganClient(event, fields) {
  if (process.env.NODE_ENV === 'test') {
    return;
  }
  console.log(
    JSON.stringify({
      tag: PREFIX,
      event,
      at: new Date().toISOString(),
      ...fields,
    })
  );
}

/**
 * @param {WebSocket|null|undefined} socket
 * @returns {object}
 */
export function socketMeta(socket) {
  if (!socket) {
    return { hasSocket: false };
  }
  return {
    hasSocket: true,
    readyState: socket.readyState,
    url: socket.url,
  };
}
